import { Chip, IconButton, Paper, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useIntegrationDataService } from "./integrationDataService";

type Props = {
  integration: any;
  onDeleted: () => void;
};

export const IntegrationCard: React.FC<Props> = ({ integration, onDeleted }) => {
  const integrationService = useIntegrationDataService();

  const handleDelete = async () => {
    if (!window.confirm(`Er du sikker på at du vil slette integrasjonen "${integration.system}"?`)) return;
    await integrationService.delete(integration.id);
    onDeleted();
  };

  const dataKeys: string[] = integration.data ? Object.keys(integration.data) : [];

  return (
    <Paper sx={{ padding: "1em", marginTop: "1em", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <div>
        <Typography variant="h6">{integration.system}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {new Date(integration.createdOn).toLocaleDateString()}
        </Typography>
        <div style={{ display: "flex", gap: "0.5em", flexWrap: "wrap" }}>
          {dataKeys.map((key) => (
            <Chip key={key} label={key} size="small" variant="outlined" />
          ))}
        </div>
      </div>
      <IconButton onClick={handleDelete} color="error" title="Slett">
        <DeleteIcon />
      </IconButton>
    </Paper>
  );
};
